module.exports = __webpack_public_path__ + "_assets/img/profile-02.d3655239.svg";